import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import CartDrawer from "./components/CartDrawer";
import Footer from "./components/Footer";

// Public pages
import Home from "./routes/Home";
import Shop from "./routes/Shop";
import ProductPage from "./routes/ProductPage";
import Checkout from "./routes/Checkout";
import OrderSuccess from "./routes/OrderSuccess";

// Admin pages
import AdminLogin from "./routes/admin/AdminLogin";
import AdminDashboard from "./routes/admin/AdminDashboard";
import AdminProducts from "./routes/admin/AdminProducts";
import AdminOrders from "./routes/admin/AdminOrders";
import AdminPrices from "./routes/admin/AdminPrices";
import Portfolio from "./routes/Portfolio";
import AiArt from "./routes/AiArt";
import CustomPrint from "./routes/CustomPrint";
import SuccessPage from "./routes/SuccessPage";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Navbar />
        <CartDrawer />
        <Routes>
          {/* ── Public Routes ───────────────────────── */}
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/ai-art" element={<AiArt />} />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/custom-print" element={<CustomPrint />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-success/:orderId" element={<OrderSuccess />} />
          <Route path="/success" element={<OrderSuccess />} />

          {/* ── Admin Routes ─────────────────────────── */}
          <Route path="/admin/login" element={<AdminLogin />} />

          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/products"
            element={
              <ProtectedRoute>
                <AdminProducts />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/prices"
            element={
              <ProtectedRoute>
                <AdminPrices />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/orders"
            element={
              <ProtectedRoute>
                <AdminOrders />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin"
            element={<Navigate to="/admin/dashboard" replace />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
